module.exports = __webpack_public_path__ + "static/images/sg.3at5aXq.svg";